module.exports = __webpack_public_path__ + "img/paula-kopi.705d7439.png";